// Utils
import { LinkCreationService, getLabelValue } from '@sportal365/smp-widget-utils';
import dayjs from 'dayjs';

// Constants
import { TARGET_BLANK, TARGET_SELF } from '../../../../../packages/constants/windowTarget';
import { assetsPlaceholder } from '../../../../../packages/constants/assetsPlaceholder';
import { COMPETITION_ENTITY, TEAM_ENTITY } from '../../../../../packages/constants/entityTypes';

// Types
import { IConfigEntityLinks, IPlayerDataLabels, ITeamInformationResponseData } from '../../../../../packages/types';

interface INormalizeTeamInformationProps {
  information?: ITeamInformationResponseData;
  dataLabels?: IPlayerDataLabels;
  dataEntityLinks?: IConfigEntityLinks | null;
}

export const normalizeTeamInformation = ({ information, dataLabels, dataEntityLinks }: INormalizeTeamInformationProps) => {
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const target = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  return {
    currentSeason: information?.current_season ? information.current_season.id : '',
    form:
      information?.form?.map(({ id, start_time, slug, outcome, result, participants }) => ({
        matchId: id,
        startTime: start_time ? dayjs(start_time).format('DD.MM.YYYY') : '',
        outcome: outcome,
        matchSummary:
          participants && participants.length > 0 && result && result.length > 0 && result[0].results.length > 0
            ? `${participants[0]?.name} ${result[0]?.results[0]?.value}:${result[0]?.results[1]?.value} ${participants[1]?.name}`
            : '',
        matchLink:
          participants && participants.length > 0
            ? linkService?.createMatchUrl(id ?? '', participants[0], participants[1], slug ?? '') ?? '#'
            : '#',
        urlTarget: target,
      })) ?? [],
    team: {
      id: information?.id ?? '',
      name: information?.name ?? '',
      image: information?.assets?.logo?.url ?? assetsPlaceholder.team,
      squad_image: information?.assets?.squad_image?.url ?? '',
      url: linkService?.createEntityUrl(information?.id ?? '', TEAM_ENTITY, '', information?.slug ?? '') ?? '#',
      founded: information?.founded ? `${getLabelValue(dataLabels?.est, 'Est')}: ${information?.founded}` : '',
      stadium: information?.venue?.name ?? '',
    },
    country: {
      id: information?.country?.id ?? '',
      name: information?.country?.name ?? '',
      image: information?.country?.assets?.flag?.url ?? assetsPlaceholder.country,
      url: '#',
    },
    tournaments: information
      ? information.active_seasons?.map(({ tournament }) => ({
          id: tournament.id ?? '',
          name: tournament.name ?? '',
          image: tournament?.assets?.logo?.url ?? assetsPlaceholder.tournament,
          url: linkService?.createEntityUrl(tournament?.id ?? '', COMPETITION_ENTITY, '', tournament?.slug ?? '') ?? '#',
        }))
      : [],
    social: {
      web: information?.social?.web ?? '',
      instagramId: information?.social?.instagram_id ?? '',
      facebookId: information?.social?.facebook_id ?? '',
      twitterId: information?.social?.twitter_id ?? '',
      youtubeChannelId: information?.social?.youtube_channel_id ?? '',
    },
    urlTarget: target,
  };
};
